import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import configureStore from './store'
import Routes from './routes'
//import './styles/css/application.css'

import './styles/css/magnific-popup.css'
import './styles/css/media-queries.css'
import './styles/css/fonts.css'
import './styles/css/default.css'
import './styles/css/layout.css'
import './styles/css/bm.css'

import registerServiceWorker from './utils/registerServiceWorker'

const store = configureStore();

render(
  <Provider store={store}>
    <Routes />
  </Provider>,
  document.getElementById('root')
)
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js